import { render, staticRenderFns } from "./inquiryList.vue?vue&type=template&id=07108712"
import script from "./inquiryList.vue?vue&type=script&lang=js"
export * from "./inquiryList.vue?vue&type=script&lang=js"
import style0 from "./inquiryList.vue?vue&type=style&index=0&id=07108712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports